<template>
  <v-dialog v-model="userCreatedDialog" max-width="700px">
    <v-card class="pa-2">
      <v-card-title primary-title class="pt-1">
        <h3 class="text-h5 mb-0">{{ $t('user.welcome.welcomeHeading') }}!</h3>

        <v-spacer></v-spacer>
        <v-btn
          :color="$vuetify.theme.dark ? '#fff' : 'primary'"
          class="px-0"
          text
          icon
          @click.stop="userCreatedDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t('user.welcome.welcomeTextOne') }}
        </p>
        <!-- <p>
          If you have a product key to redeem or wish to visit the store to purchase additional
          products, please choose an option below.
        </p> -->

        <v-layout wrap justify-center class="pb-4">
          <v-flex xs12 sm5>
            <router-link to="/shop">
              <v-btn class="custom-button" color="primary" block>
                {{ $t('user.welcome.storeBtn') }}
              </v-btn>
            </router-link>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <ProductKey minimal :buttonText="$t('user.welcome.redeemBtn')" />
          </v-flex>
        </v-layout>

        <p>
          {{ $t('user.welcome.welcomeTextTwo') }}
        </p>

        <p>
          {{ $t('user.welcome.welcomeTextThree') }}
          <a
            href="https://trugolf.com/pages/downloads"
            target="_blank"
            class="download_link text-uppercase"
          >
            {{ $t('user.welcome.tgDownloads') }}
          </a>
        </p>

        <p>
          {{ $t('user.welcome.welcomeTextFour') }}
        </p>

        <!-- <p>
          You will need to activate your account to ensure access to your player data and this
          website.<br />
          Please check your email for instructions.
        </p> -->

        <!-- <p>
          If you own a tracking system and have activated your account, we encourage you to download
          and play the E6 CONNECT Demo.
        </p> -->

        <!-- <p>
          You can download the latest version of our E6 CONNECT Demo here:
          <router-link to="/update/e6-connect">E6 Connect Downloads</router-link>
        </p>

        <p>
          Once installed, you can activate your Demo License in the game. The Demo gives you access
          to our practice range, and the beautiful Aviara in Carlsbad California.
        </p> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductKey from '@/components/ProductKey';

export default {
  name: 'WelcomeDialog',

  components: {
    ProductKey,
  },

  computed: {
    userCreatedDialog: {
      get() {
        return this.$route.query.newUser;
      },
      set(value) {
        this.$router.push(this.$route.path).catch(() => {});
      },
    },
  },
};
</script>

<style scoped>
.custom-button {
  height: 64px !important;
  /* width: 250px !important; */ /** This was originally added with container width */
  margin: 20px auto;
  font-size: 18px !important;
  font-weight: 400 !important;
}

.custom-button-dark {
  background-color: #6d6d6d !important;
  background-color: var(--grey) !important;
}

/* Underline styles */
a.download_link {
  display: inline-block;
  position: relative;
  padding: 0.2em 0;
}

/* Fade in */
a.download_link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.1em;
  background-color: var(--primary, #ba2127);
  opacity: 0;
  transition: opacity 300ms, transform 300ms;
}

a.download_link:hover::after,
a.download_link:focus::after {
  opacity: 1;
  transform: translate3d(0, 0.2em, 0);
}

.download_link {
  font-weight: bold;
  transition: all 0.3s ease-in-out;
}

@media (max-width: 960px) {
  .custom-button {
    /* width: 170px; */ /** This was originally added with container width */
    font-size: 16px;
  }
}

@media (max-width: 600px) {
  /** This was originally added with container width */
  /* .custom-button {
    width: 90%;
  } */
}
</style>
